import React, { useEffect, lazy, Suspense } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Layout/Header";
import ProductDetails from "../components/Products/ProductDetails";
import Loader from "../components/Layout/Loader";

// Lazy load below-the-fold components
const SuggestedProduct = lazy(() => import("../components/Products/SuggestedProduct"));
const Footer = lazy(() => import("../components/Layout/Footer"));

const ProductDetailsPage = () => {
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />
      <ProductDetails />
      <Suspense fallback={<Loader />}>
        <SuggestedProduct productId={id} />
      </Suspense>
      <Suspense fallback={<div style={{ minHeight: '200px' }} />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default ProductDetailsPage;
